var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2696 37.5467V31.4312C13.2696 29.8701 14.5443 28.6046 16.1169 28.6046H21.8652C22.6204 28.6046 23.3446 28.9024 23.8786 29.4325C24.4126 29.9626 24.7125 30.6816 24.7125 31.4312V37.5467C24.7078 38.1957 24.9641 38.8198 25.4247 39.2804C25.8854 39.741 26.5121 40 27.1659 40H31.0877C32.9193 40.0047 34.6775 39.2857 35.9743 38.0016C37.2712 36.7175 38 34.974 38 33.1556V15.7337C38 14.2649 37.3441 12.8717 36.2092 11.9293L22.868 1.35174C20.5473 -0.502877 17.2222 -0.442996 14.9708 1.49396L1.93402 11.9293C0.745481 12.8439 0.0351046 14.2413 0 15.7337V33.1379C0 36.9277 3.09476 40 6.91235 40H10.7446C12.1025 40 13.206 38.9124 13.2158 37.5645L13.2696 37.5467Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.68f11e380171f4253b8489d8622906eb.svg";
export { ForwardRef as ReactComponent };